import { AfterViewInit, Component, NgZone } from '@angular/core';
import { AccessManager } from '../../ui/access-manager/access-manager';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { AdminService } from '../../../models/admin/adminService';
import { MerchantGroup } from '../../../models/merchant/merchantGroup';
import { SimpleDialogComponent, SimpleDialogData } from '../../../../../../../libs/Shared/components/dialogs/simple-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-merchant-groups',
  templateUrl: './merchant-groups.component.html',
  standalone: false,
})
export class MerchantGroupsComponent implements AfterViewInit {
  hasReadAccess = false;
  hasWriteAccess = false;
  namespace = AccessManager.AUTH_SELECT_MERCHANT_GROUPS;
  records: MerchantGroup[] = [];
  isEditing: boolean = false;
  loading: boolean = false;
  newGroupName: string | undefined;

  constructor(
    private accessManager: AccessManager,
    private adminService: AdminService,
    private ngZone: NgZone,
    private uiErrorHandler: UIErrorHandler,
    private dialog: MatDialog,
  ) {}

  ngAfterViewInit(): void {}

  ngOnInit() {
    this.accessManager
      .getUserAccess([
        AccessManager.AUTH_UPDATE_MERCHANT_GROUPS,
        AccessManager.AUTH_SELECT_MERCHANT_GROUPS,
      ])
      .then((access) => {
        this.hasReadAccess = access[AccessManager.AUTH_SELECT_MERCHANT_GROUPS];
        this.hasWriteAccess = access[AccessManager.AUTH_UPDATE_MERCHANT_GROUPS];
        console.log(this.hasReadAccess, this.hasWriteAccess);

        if (this.hasReadAccess) {
          this.reload();
        }
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  public select(record: Partial<MerchantGroup>) {
    const dialogRef = this.dialog.open<SimpleDialogComponent, SimpleDialogData, string | null>(
      SimpleDialogComponent,
      {
        data: {
          new: false,
          name: record.name,
          title: 'Rename Group',
          label: 'Group Name',
          submitText: 'Update',
          required: true,
        },
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== null && result !== undefined && result !== record.name) {
        this.save(record.name as string, result);
      }
    });
  }

  public btnDelete_click(record: MerchantGroup) {
    if (confirm(`Are you sure you want to delete group ${record.name}?`)) {
      this.adminService.deleteGroup(record.name).then(() => {
        this.reload();
      });
    }
  }

  public save(oldName: string, newName: string) {
    this.adminService.updateGroup(oldName, newName).then(() => {
      this.reload();
    });
  }

  public create() {
    const dialogRef = this.dialog.open<SimpleDialogComponent, SimpleDialogData, string | null>(
      SimpleDialogComponent,
      {
        data: {
          new: false,
          name: '',
          title: 'Create Account Group',
          label: 'Group Name',
          submitText: 'Create',
          required: true,
        },
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (!!result) {
        this.adminService.createGroup(result.trim()).then(() => {
          this.reload();
        });
      }
    });
  }

  async reload() {
    this.ngZone.run(async () => {
      this.loading = true;

      this.adminService
        .getMerchantGroups()
        .then((items) => {
          this.records = items;
          this.loading = false;
        })
        .catch((message) => {
          this.uiErrorHandler.handleError(message);
        });
    });
  }

}
